import { useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { IconWifiOff } from './icons';
import { toast } from './toast';

function useOnline() {
  const [online, setOnline] = useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine));
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  return online;
}

/** Offline pill + one-time "ready offline" notice. SW auto-updates (registerType: autoUpdate). */
export function PwaStatus() {
  const online = useOnline();
  const {
    offlineReady: [offlineReady, setOfflineReady],
  } = useRegisterSW({
    onRegisterError(err) {
      console.warn('Service worker registration failed', err);
    },
  });

  useEffect(() => {
    if (offlineReady) {
      toast.success('Cady is ready to work offline.');
      setOfflineReady(false);
    }
  }, [offlineReady, setOfflineReady]);

  if (online) return null;
  return (
    <div
      role="status"
      className="fixed inset-x-0 bottom-[calc(var(--safe-bottom)+5.5rem)] z-30 flex justify-center px-4"
    >
      <span className="inline-flex items-center gap-2 rounded-full bg-primary px-4 py-2 text-sm font-semibold text-on-primary shadow-lg">
        <IconWifiOff size={18} /> You're offline
      </span>
    </div>
  );
}
